import { consoleEvents } from '@pb/utils'
import { path, pathOr, curry } from 'ramda'

/**
 * get a property of a multi-level object without getting errors
 * @param {object} rootObject The root object that contains keys further down the object tree
 * @param {array} propertyPath Path on rootObject to target properties. Example: ['obj', 'arr', 0]
 * @param {string} substitute What is gonna be replaced with if no match. Defaults to {arrayOfKeys}
 */

const getPropertyOr = curry((substitute, propertyPath, rootObject) => {
  const pathValue = path(propertyPath, rootObject)
  if (typeof pathValue === 'undefined') {
    consoleEvents.error(`Invalid path "${propertyPath}", instead returning "${substitute}"`)
    return substitute
  }
  return pathOr(substitute, propertyPath, rootObject)
})

export default getPropertyOr
